import { authApi } from './client';

const ACCEPT_JSON = { 'Accept': 'application/json' };

// Query de las tablas de solicitudes. Todos los filtros se envían siempre, aunque no tengan valor
// (p. ej. `estado=undefined`), igual que antes del refactor.
const requestListQuery = params => {
    const baseQuery = `?pageSize=${params.pageSize}&page=${params.page}`;
    const filterQueries = [
        `estado=${params.estado}`,
        `nroSolicitud=${params.nroSolicitud}`,
        `fechaCreacion=${params.fechaCreacion}`,
        `fechaResolucion=${params.fechaResolucion}`,
        `fechaCreacionDate=${params.fechaCreacionDate}`,
        `nombreCorreo=${params.nombreCorreo}`,
        `fechaCreacionOrder=${params.fechaCreacionOrder}`,
        `fechaResolucionOrder=${params.fechaResolucionOrder}`,
        `fechaCreacionDateOrder=${params.fechaCreacionDateOrder}`,
        `estadoOrder=${params.estadoOrder}`,
    ];
    return `${baseQuery}&${filterQueries.join('&')}`;
};

// Solicitudes del usuario (profesor).
export const getMyRequests = params =>
    authApi.get(`/pedidos/${requestListQuery(params)}`, { headers: ACCEPT_JSON });

// Todas las solicitudes (pañolero).
export const getAllRequests = params =>
    authApi.get(`/pedidos/all/${requestListQuery(params)}`, { headers: ACCEPT_JSON });

export const getRequest = id =>
    authApi.get(`/pedido/${id}`, { headers: ACCEPT_JSON });

export const getRequestItems = id =>
    authApi.get(`/get-producto-id-pedido/${id}`);

export const createRequest = pedido =>
    authApi.post('/crear-pedido-final/', pedido, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } });

export const resolveRequest = (pedidoId, estado, comentario) =>
    authApi.post(`/resolver-pedidos/?pedidoId=${pedidoId}&estado=${estado}`, { comentario }, { headers: ACCEPT_JSON });
